import { css } from '@emotion/react'
 /** @jsxImportSource @emotion/react */
import React,{ useState} from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import { Form, Input, Modal, Select  } from 'antd';
import {ButtonBase} from '@mui/material';
import Button from '@mui/material/Button';
import { ExclamationCircleFilled } from '@ant-design/icons';

import axios from '../apiClient';
import Alert from '../alert';
import Loader from '../loader';
import moment from 'moment';


export default function MatchResultEdit() {
  const [loading,setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [modalLoading,setModalLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const {matchId,matchStatus} = location.state.rowData;
  
  const onFinish = async (values) => {
    const {firstHalfScoreForHomeTeam,firstHalfScoreForAwayTeam,fullTimeScoreForHomeTeam,fullTimeScoreForAwayTeam, matchStatus} = values;
    setLoading(true)
    const inputFormat = 'DD-MM-YYYY h:mm A';
    const outputFormat = 'YYYY-MM-DD HH:mm:ss';
    const formattedDate = moment(values.matchTime, inputFormat).format(outputFormat)
    const params ={
        matchId: matchId,
        // matchStatus: matchStatus == "NS" ? "FT" : matchStatus,
        matchStatus: matchStatus,
        scores: {
            fulltime: {
                away: fullTimeScoreForAwayTeam || null ,
                home: fullTimeScoreForHomeTeam || null
            },
            halftime: {
                away: firstHalfScoreForAwayTeam || null,
                home: firstHalfScoreForHomeTeam || null
            },
        }
    };
    const resUpdatingMatch = await axios.put(`/info/updateMatchById`,params)
    const resUpdatingMatchTime = await axios.put(`/bet/updateMatchDate?matchId=${matchId}&matchDate=${formattedDate}`)
    let msg;let code;
    if( resUpdatingMatch.code != 200 || resUpdatingMatchTime.code != 200){
      msg= "Update Failed";
      code= 500;
    }else{
      msg = "Successfully Updated";
      code = 200;
    }

    setErrorMsg({ code, msg })
    setLoading(false)
    setOpenAlert(true)
  };
  //https://api.kl36.bet/bet/refund?matchId=1167114
  const cancel2HFT = async () =>{
    setModalLoading(true)
    const response = await axios.put(`/bet/refund?matchId=${matchId}`)
    setModalLoading(false);
    if(response.code == 200){
      navigate("/reports/matchResult")
    }
    setErrorMsg({ code : response.code, msg : response.message })
    setLoading(false)
    setOpenAlert(true)
  }
  const cancelMatchApi = async () =>{
    setModalLoading(true)
    const response = await axios.put(`/bet/cancelMatch?matchIds=${matchId}`)
    setModalLoading(false);
    if(response.code == 200){
      navigate("/reports/matchResult")
    }
    setErrorMsg({ code : response.code, msg : response.message })
    setLoading(false)
    setOpenAlert(true)
  }

  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
  return (
    <div
      css={css`
        /* background-color: #ffffff; */
        border-radius: 1rem;
        padding: 1rem;
      `}
    >
      
      <div style={{padding: "0 10rem"}}>
          <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
          <Form
            name="basic"
            onFinish={onFinish}
            autoComplete="off"
          >
            <Upper cancelMatchApi={cancelMatchApi} modalLoading={modalLoading} cancel2HFT={cancel2HFT}/>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                padding: "0 2rem",
                marginTop: "2rem",
              }}
            >
              <ButtonBase
                type="submit"
                component="button"
                style={{
                  color: "white",
                  display: "flex",
                  backgroundColor: "#5e35b1",
                  padding: "0.6rem 1.8rem",
                  borderRadius: "2rem",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                 {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 }}>Edit</h4>}
              </ButtonBase>
            </div>
          </Form>
      </div>
    </div>
  );
}

const Upper = ({cancelMatchApi,modalLoading,cancel2HFT}) =>{
  const location = useLocation();
  const [isModalOpen,setModalOpen] = useState(false);
  const {name,firstHalfScore,secondHalfScore,fullTimeScore,matchDate,matchStatus} = location.state.rowData;

  const HomeTeamName = name.split('-')[0];
  const AwayTeamName = name.split('-')[1];

  const firstHalfScoreForHomeTeam = firstHalfScore.split('-')[0];
  const firstHalfScoreForAwayTeam = firstHalfScore.split('-')[1];

  const secondHalfScoreForHomeTeam = secondHalfScore.split('-')[0];
  const secondHalfScoreForAwayTeam = secondHalfScore.split('-')[1];

  const fullTimeScoreForHomeTeam = fullTimeScore.split('-')[0];
  const fullTimeScoreForAwayTeam = fullTimeScore.split('-')[1];
  const { confirm } = Modal;
  const showConfirm = () => {
    confirm({
      mask: false,
      centered: true,
      maskClosable: true, 
      title: 'Do you Want to cancel this match?',
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: modalLoading ? <Loader btn={true}/> : "OK",
      onOk() {
        cancelMatchApi()
      },
      onCancel() {
        setModalOpen(false)
      },
    });
  };
  const showConfirm2HFT = () => {
    confirm({
      mask: false,
      centered: true,
      maskClosable: true, 
      title: 'Do you Want to cancel 2H & FT?',
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: modalLoading ? <Loader btn={true}/> : "OK",
      onOk() {
        cancel2HFT()
      },
      onCancel() {
        setModalOpen(false)
      },
    });
  };
  return (
    <div>
        <div style={{display: 'flex',alignItems: "center",justifyContent: 'space-between',}}>
            <div style={{display: 'flex',alignItems: "center"}}>
              <div style={{display: "flex",alignItems: 'center'}}>
                  <h3 style={{marginRight: '1rem',fontWeight: "bold",fontStyle: "italic",color: 'gray'}}>Time: </h3>
                  <Form.Item
                    style={{color: "black",margin: "0 1rem 0 0",fontWeight: "normal"}}
                    wrapperCol={{ span: 24 }}
                    name="matchTime"
                    initialValue={matchDate}
                  >
                    <Input size="large"/>
                  </Form.Item>
              
              </div>
              <div style={{display: "flex",alignItems: 'center'}}>
                  <h3 style={{marginRight: "1rem",fontWeight: "bold",fontStyle: "italic",color: 'gray'}}>Status: </h3>
                  {/* <span style={{color: "black",marginLeft: "1rem",fontWeight: "normal"}}>{matchStatus}</span> */}
                  <Form.Item
                    style={{margin: 0}}
                    name="matchStatus"
                    initialValue={matchStatus}
                  >
                    <Select
                      style={{width: "70px",marginRight: "1rem"}}
                      // filterOption={(inputValue, option)=> {return option.label.toLowerCase().includes(inputValue.toLowerCase());}}
                      showSearch
                      options={[{value: "FT",label: "FT"},{value: "1H",label: "1H"},{value: "HT",label: "HT"},{value: "2H",label: "2H"}]}
                      placeholder="Select Category"
                    />
                  </Form.Item>
              </div>
            </div>
            <Button variant="contained" color="error" onClick={showConfirm}>
              Cancel this match
            </Button>
            <Button variant="contained" color="error" onClick={showConfirm2HFT}>
              Cancel 2H & FT
            </Button>
           
        </div>
        <div
        css={css`
        /* background-color: #EEEEEE; */
        padding: 1rem;
        border-radius: 1rem;
        margin: 1rem;
        box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
        -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
          `}
        >
          <div style={{display: 'flex',alignItems: "center"}}>
           <div style={{flexBasis: "25%"}}>
            </div>
            <div style={{flexBasis: "50%"}}>
                <h3 style={{marginBottom: '24px',marginLeft: '1rem',fontWeight: "bold",fontStyle: "italic"}}>First Half Score</h3>
            </div>
            <div style={{flexBasis: "50%"}}>
                <h3 style={{marginBottom: '24px',marginLeft: '1rem',fontWeight: "bold",fontStyle: "italic"}}>Full Time Score</h3>
            </div>
          </div>
          <div style={{display: 'flex',alignItems: "center"}}>
            <div style={{flexBasis: "25%"}}>
                <h3 style={{marginBottom: '24px',marginLeft: '1rem',fontWeight: "normal"}}>{HomeTeamName}</h3>
            </div>
            <Form.Item
              style={{flexBasis: "50%",padding: "0 0.4rem", color: "white"}}
              wrapperCol={{ span: 24 }}
              name="firstHalfScoreForHomeTeam"
              initialValue={firstHalfScoreForHomeTeam}
            >
              <Input size="large" type='number'/>
            </Form.Item>

            <Form.Item
              style={{flexBasis: "50%",padding: "0 0.4rem", color: "white"}}
              wrapperCol={{ span: 24 }}
              name="fullTimeScoreForHomeTeam"
              initialValue={fullTimeScoreForHomeTeam}
            >
              <Input size="large" type='number'/>
            </Form.Item>
          </div>
          <div style={{display: 'flex',alignItems: "center"}}>
            <div style={{flexBasis: "25%"}}>
                <h3 style={{marginBottom: '24px',marginLeft: '1rem',fontWeight: "normal"}}>{AwayTeamName}</h3>
            </div>
            <Form.Item
              style={{flexBasis: "50%",padding: "0 0.4rem", color: "white"}}
              wrapperCol={{ span: 24 }}
              name="firstHalfScoreForAwayTeam"
              initialValue={firstHalfScoreForAwayTeam}
            >
              <Input size="large" type='number' />
            </Form.Item>

            <Form.Item
              style={{flexBasis: "50%",padding: "0 0.4rem", color: "white"}}
              wrapperCol={{ span: 24 }}
              name="fullTimeScoreForAwayTeam"
              initialValue={fullTimeScoreForAwayTeam}
            >
              <Input size="large" type='number'/>
            </Form.Item>
          </div>
        </div>
    </div>
  );
}
